import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form, Loader, utils} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";
import * as subjektActions from "../actions/subjektActions";
import {getIdFromProps} from "../utils/utils";
import * as polozkaActions from "../actions/polozkaActions";
import {CENIKY_SPOLECNOST_LIST_AREA} from "../actions/polozkaActions";
import moment from "moment/moment";
import {Simulate} from "react-dom/test-utils";
import change = Simulate.change;
const {Form, FormActions, FormBody} = form;

/**
 * Formulář pro pripojeni ceníku ke spolecnosti.
 */
class PripojCenikForm extends Component<WithTranslation> {

    static formName = 'PripojCenikForm';

    static validate = (values, props) => {
        const {t} = props;
        const errors = {};
        if (!values.cenikId) {
            errors.cenikId = t('validation.price_list_required');
        }
        return errors;
    };

    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(polozkaActions.fetchCenikyIfNeeded());
    };

    handleCenikChange = (event) => {
        if (event && event.target.value && parseInt(event.target.value)) {
            change('cenikId', parseInt(event.target.value))
        }
    }

    render() {
        const {cenikyList, onClose, submitting, handleSubmit, changed, t} = this.props;

        if (!cenikyList.fetched) {
            return <Loader/>;
        }

        if (cenikyList.rows.length > 0 && (!document.getElementById("cenikSelect") || !document.getElementById("cenikSelect").value)) {
            change('cenikId', cenikyList.rows[0].id)
        }

        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.Select id={"cenikSelect"} required label={t('admin.price_list',{priceListID: ''})} name="cenikId" disabled={submitting} onChange={this.handleCenikChange}>
                    {cenikyList.rows.map((c)=><option key={'cenik_' + c.id} value={c.id}>{c.nazevCenik}</option>)}
                </ff.Select>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('attach')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

function mapStateToProps(state) {
    return {
        cenikyList: utils.storeFromArea(state, polozkaActions.CENIKY_LIST_AREA),
        changed: false
    }
}

export default withTranslation()(connect(mapStateToProps)(reduxForm({
    form: PripojCenikForm.formName,
    validate: PripojCenikForm.validate,
})(PripojCenikForm)));
